import React from "react";
// import {SortableContainer} from 'react-sortable-hoc';
import NoteItem from 'ui/components/noteItem';

class NoteList extends React.PureComponent {
  render() {
    const { onEdit, onDelete, items } = this.props;
    return (
      <div className='noteListItems'>
        {items.map((item, index) => (
          <NoteItem
            key={`item-${item.id}`}
            index={index}
            disabled={true}
            onEdit={onEdit}
            onDelete={onDelete}
            {...item}
          />
        ))}
      </div>
    );
  }
}

// export default SortableContainer(NoteList);
export default NoteList;
